import Vue from "vue";
import Home from "../views/Home.vue";
import Register from "../views/Register.vue";
import Login from "../views/Login.vue";
import Contests from "../views/Contests.vue";
import Demos from "../views/Demos.vue";
import Editor from "../views/Editor.vue";
import Billing from "../views/Billing.vue";
import DemoDetail from "../views/Demo.vue";
import VueRouter from 'vue-router'
import Settings from "../views/Settings.vue";

Vue.use(VueRouter)

const routes = [
  {
    path: "/",
    name: "home",
    component: Home,
    beforeEnter: (to, from, next) => {
      return auth(to, from, next);
    }
  },
  {
    path: "/submissions",
    name: "submissions",
    component: Demos,
    beforeEnter: (to, from, next) => {
      return auth(to, from, next);
    }
  },
  {
    path: "/login",
    name: "login",
    component: Login,
  },
  {
    path: "/register",
    name: "register",
    component: Register
  },
  {
    path: "/contests",
    name: "contests",
    component: Contests,
    beforeEnter: (to, from, next) => {
      return auth(to, from, next);
    }
  },
  {
    path: "/contest/:id",
    name: "contest-detail",
    component: Editor,
    beforeEnter: (to, from, next) => {
      return auth(to, from, next);
    }
  },
  {
    path: "/submissions/:id",
    name: "DemoDetail",
    component: DemoDetail,
    beforeEnter: (to, from, next) => {
      return auth(to, from, next);
    }
  },
  {
    path: "/billing",
    name: "billing",
    component: Billing,
    beforeEnter: (to, from, next) => {
      return auth(to, from, next);
    },
  },
  {
    path: "/settings",
    name: "settings",
    component: Settings,
    beforeEnter: (to, from, next) => {
      return auth(to, from, next);
    },
  }
]

const router = new VueRouter({
  mode: 'history',
  linkExactActiveClass: 'sidebar-link-active',
  routes
})

function auth(to, from, next) {
  if (!localStorage.getItem('token')) {
    return router.push({ name: 'login' });
  } else {
    return next();
  }
}

export default router
